import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import PredesComplianceIncorrectLocationCodeUsageReport from '../components/PredesComplianceIncorrectLocationCodeUsageReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/PredesComplianceIncorrectLocationCodeUsageDetailsSelectors';

export function PredesComplianceIncorrectLocationCodeUsageDetailsContainer(props) {
  return (
    <PredesComplianceIncorrectLocationCodeUsageReport
      reportId={ReportDefinitions.PREDES_COMPLIANCE_INCORRECT_LOCATION_CODE_USAGE_DETAILS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

PredesComplianceIncorrectLocationCodeUsageDetailsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(PredesComplianceIncorrectLocationCodeUsageDetailsContainer);
